/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_TitleInputs */

const cs_blog_website_title = /** @type {(inputs: Blog_Website_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web kanceláře`)
};

const en_blog_website_title = /** @type {(inputs: Blog_Website_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency website`)
};

/**
* | output |
* | --- |
* | "Agency website" |
*
* @param {Blog_Website_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_title = /** @type {((inputs?: Blog_Website_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_title(inputs)
	return cs_blog_website_title(inputs)
});